import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {map, Observable} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import {AccountService, DataStateService} from '../service';
import {TranslateService} from '@ngx-translate/core';
import {XSRF_TOKEN_COOKIE} from '../../shared/constants/app-constants';
import {TipoProfilo} from '../../shared/models';
import {environment} from '../../../environments/environment';
import {DialogsUtilsService} from '../service/utils/dialogs-utils.service';

export const AuthGuard: CanActivateFn = (route, state): boolean | Observable<boolean> => {

	const cookieService = inject(CookieService);
	const stateService = inject(DataStateService);
	const router = inject(Router);
	const dialogUtils = inject(DialogsUtilsService);
	const translate = inject(TranslateService);
	const account = inject(AccountService);

	const hasXSRF = !!cookieService.get(XSRF_TOKEN_COOKIE);
	const profiliRoute: TipoProfilo[] = route.data['authorities'] ?? [];

	if (state.url.includes('re-login')) {
		window.location.href = environment.loginURL;
		return false;
	}

	if (state.url.includes('/documenti') && stateService.dossierReadonly) {
		// tentativo di accedere ai documenti del dossier in modalità "readonly" --> blocco routing
		router.navigate(['applicazioni']);
		return false;
	}

	if (!hasXSRF) {
		router.navigate(['login']);
		return false;
	}

	// verifica reale (non solo lo stato locale, che su una sessione appena creata - es. subito dopo il login OAuth2 -
	// non è ancora stato popolato da nessuno): identity() interroga il BE e usa la cache se già disponibile
	return account.identity().pipe(map(loggedUser => {
		if (!loggedUser) {
			router.navigate(['login']);
			return false;
		}

		if (!profiliRoute.length) {
			return true;
		}

		if (!loggedUser.profili.some(p => profiliRoute.includes(p.profilo))) {
			dialogUtils.openAdviseDialog(translate.instant('errore'), translate.instant('error_authorities'));
			router.navigate(['applicazioni']);
			return false;
		}

		return true;
	}));
};
